export default "__VITE_ASSET__tzDN3LdP__"